"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _form = require("../actions/form");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var initialState = {
  currentStep: "service",
  steps: [],
  finishedSteps: [],
  errorMessage: "",
  isSubmitting: false,
  hasSubmitted: false
};

var form = function form() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _form.CONFIGURE:
      return _extends({}, state, {
        steps: action.formSteps,
        summarySteps: action.summarySteps,
        currentStep: action.formSteps[0]
      });

    case _form.FINISH_STEP:
      var finishedSteps = state.finishedSteps;

      if (state.finishedSteps.indexOf(action.step) === -1) {
        finishedSteps.push(action.step);
      }

      return _extends({}, state, {
        finishedSteps: [].concat(_toConsumableArray(finishedSteps))
      });

    case _form.NEXT_STEP:
      var nextStep = findUnfinishedStep(state.steps, state.finishedSteps);
      return _extends({}, state, {
        currentStep: nextStep
      });

    case _form.SELECT_STEP:
      return _extends({}, state, {
        currentStep: action.step
      });

    case _form.RESET_STEP:
      return _extends({}, state, {
        finishedSteps: _underscore2.default.without(state.finishedSteps, action.step)
      });

    case _form.SUBMIT_REQUEST:
      return _extends({}, state, {
        isSubmitting: true,
        hasSubmitted: false,
        errorMessage: ""
      });

    case _form.SUBMIT_SUCCESS:
      return _extends({}, state, {
        isSubmitting: false,
        hasSubmitted: true,
        errorMessage: ""
      });

    case _form.SUBMIT_FAILURE:
      return _extends({}, state, {
        isSubmitting: false,
        hasSubmitted: false,
        errorMessage: action.error
      });

    case _form.RESET_FORM_DATA:
      return _extends({}, state, {
        currentStep: state.steps[0],
        finishedSteps: []
      });

    default:
      return state;
  }
};

function findUnfinishedStep(steps, finishedSteps) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = steps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var step = _step.value;

      if (finishedSteps.indexOf(step) === -1) {
        return step;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
}

exports.default = form;